"use client";

import type { MutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { fetchAuthSession } from "aws-amplify/auth";
import { scanInsuranceCard, type ScanInsuranceCardResult } from "@rmh/utils";
import { fetchGraphQLClient } from "../../../amplify/fetchGraphQLClient";

export interface ScanInsuranceCardVariables {
  frontFile: File;
  backFile?: File;
}

/**
 * Upload the captured insurance-card image(s) and run OCR extraction.
 */
export const useScanInsuranceCard = (
  options: MutationOptions<
    ScanInsuranceCardResult,
    Error,
    ScanInsuranceCardVariables
  > = {}
) =>
  useMutation<ScanInsuranceCardResult, Error, ScanInsuranceCardVariables>({
    ...options,
    mutationFn: async ({ frontFile, backFile }) => {
      const session = await fetchAuthSession();
      const userSub = session.userSub;
      const token = session.tokens?.idToken?.toString();

      if (!userSub || !token) {
        throw new Error(
          "No authenticated session for the insurance card scan."
        );
      }

      return scanInsuranceCard({
        frontFile,
        backFile,
        userSub,
        token,
        fetchExtractInsuranceCard: fetchGraphQLClient,
      });
    },
  });
